import { useMemo } from 'react'
import { useQuery } from '@apollo/client'
import { useQueryVariables } from '../store'
import {
  OPERATION_FIND_COUPONS_AGGS_H3,
  OPERATION_FIND_COUPONS_AGGS_STANDARD,
} from '../operations-gql/queries'

const useAggregation = ({ isStandard }) => {
  const queryVariables = useQueryVariables()

  const { data, loading, error } = useQuery(
    isStandard
      ? OPERATION_FIND_COUPONS_AGGS_STANDARD
      : OPERATION_FIND_COUPONS_AGGS_H3,
    {
      variables: queryVariables,
    }
  )

  const counters = useMemo(
    () => {
      if (!data) {
        return {}
      }
      return ({
        available: data.aggs.find((agg) => agg.key === 'available')?.count,
        available_soon: data.aggs.find((agg) => agg.key === 'available_soon')?.count,
        used: data.aggs.find((agg) => agg.key === 'used')?.count,
        disabled: data.aggs.find((agg) => agg.key === 'disabled')?.count,
        expired: data.aggs.find((agg) => agg.key === 'expired')?.count,
      })
    },
    [data, isStandard],
  )

  return {
    error,
    loading,
    counters,
  }
}

export default useAggregation
